import './base/theme.js';
import './layout/sidebar.js';
import './base/utils.js';
import './components/index.js';
import { initNavbar } from './layout/navbar';

// Initialize Components
document.addEventListener('DOMContentLoaded', () => {
    // Assuming refreshIcons() is defined elsewhere or will be added
    // refreshIcons(); // Initial load
    // Assuming initSidebar() is exported from './layout/sidebar.js'
    // initSidebar();
    initNavbar();
});
